import { useState } from 'react';
import { useParams } from 'react-router-dom';
import strings from '../../../../../../common/Translation/Translate';
import { routes } from '../../../../../../utils/constants/routes';
import { URLS } from '../../../../../../utils/constants/urls';
import AddEdit from '../../../../CommonPage/AddEdit';
import { ParentOrgMediaForm } from './ParentOrgMediaForm';

type MediaTabProps = {
  pageResponse: any;
  setPageResponse: any;
};

const ParentOrgMedia = ({ pageResponse, setPageResponse }: MediaTabProps) => {
  const { id } = useParams() as any;
  const [logoDeleteFile, setLogoDeleteFile] = useState<any>([]);

  const pageConfig = {
    title: strings.parentOrg_title_update,
    successMessage: strings.common_update_message,
    addEditApiUrl: URLS.updateParentOrganizationMediaInfo(id),
    formModel: ParentOrgMediaForm(strings),
    navigateToPage: routes.parentOrganization,
    isCustomResponse: true,
    isFormData: true,
    hideClose:true
  };

  const handleCustomResponse = (custom: any) => {
    const formData = new FormData();

    if (custom.logo || pageResponse.logo) {
      (custom.logo ?? pageResponse.logo).forEach((file: any) => {
        formData.append('logo', file);
      });
    } else {
      formData.append('logo', null as any);
    }

    if (custom.favicon || pageResponse.favicon) {
      (custom.favicon ?? pageResponse.favicon).forEach((file: any) => {
        formData.append('favicon', file);
      });
    } else {
      formData.append('favicon', null as any);
    }
    formData.append('deletedLogo', logoDeleteFile);

    return formData;
  };

  const deleteParentImages = (key: string, _value: string, _formData: any, isDeleted: any) => {
    if (Array.isArray(isDeleted) && isDeleted[0].id) {
      const name = isDeleted[0].name;
      switch (key) {
        case 'logo':
          setLogoDeleteFile(name);
          setPageResponse({ ...pageResponse, logo: '' });
          break;
        case 'favicon':
          setPageResponse({ ...pageResponse, favicon: '' });
          break;
      }
    }
  };

  const handleFormChange = (key: string, value: string, formData: any, isDeleted: any) => {
    if (key === 'logo' || key === 'favicon') {
      deleteParentImages(key, value, formData, isDeleted);
    }
  };

  return (
    <AddEdit
      handlePropsChange={handleFormChange}
      pageConfig={pageConfig}
      pageResponse={pageResponse}
      handleCustomResponse={handleCustomResponse as any}
    />
  );
};
export default ParentOrgMedia;
